import React from 'react'
import { Updater, async, fromJSX, nothing, Widget, any } from 'widgets-for-react'
import { InviewProps, SVGIconProps } from '../blocksState'
import { AllCourseGroupsBlockLayout } from './allCourseGroupsBlockLayout'
import {
  AllCourseGroups,
  AllCourseGroupsBlockState
} from './allCourseGroupsBlockState'

export type AllCourseGroupsBlock = {
  index: number
  inview?: InviewProps
  title?: React.ReactNode
  courseGroupsState: AllCourseGroupsBlockState
  SVGIcon?: SVGIconProps
}

export const allCourseGroupsBlockWidget = (
  block: AllCourseGroupsBlock
): Widget<Updater<AllCourseGroupsBlockState>> => {
  const groups = block.courseGroupsState.allCourseGroupsState
  return any<Updater<AllCourseGroupsBlockState>>([
    groups.kind == 'loaded'
      ? fromJSX(setState => (
          <AllCourseGroupsBlockLayout
            {...block}
            children={groups.value}
            query={block.courseGroupsState.query}
            setQuery={(newQuery: string) =>
              setState(s => ({ ...s, query: newQuery }))
            }
          />
        ))
      : nothing(),
    async<AllCourseGroups>(
      block.courseGroupsState.allCourseGroupsState
    ).map(updater => s => ({
      ...s,
      allCourseGroupsState: updater(s.allCourseGroupsState)
    }))
  ])
}
